<template>
  <div>
<vs-input class="w-full mb-4" v-model="limit_balance" :label-placeholder="'上级账户余额限制'" />
    <vs-table stripe :data="dataLocal" noDataText="暂无规则">
      <template slot="header">
        <div class="w-full mb-2 flex items-center justify-between">
          <h4>规则</h4>
          <vs-button color="success" size="small" @click="add">添加</vs-button>
        </div>
      </template>
      <template slot="thead">
        <vs-th width="80">充值(USDT)</vs-th>
		<vs-th width="80">上级</vs-th>
		<vs-th width="80">上上级</vs-th>
		<vs-th width="80">上上上级</vs-th>
        <vs-th width="80">自身</vs-th>
        <!-- <vs-th width="80">赠金(%)</vs-th>
        <vs-th width="80">流水(元)</vs-th> -->
        <vs-th width="60">
          <div class="text-center w-full">操作</div>
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="index" v-for="(item, index) in dataLocal" >
          <vs-td :data="item.recharge">
            <vs-input class="w-full" v-model="dataLocal[index].recharge" />
          </vs-td>
		  <vs-td :data="item.first">
		    <vs-input class="w-full" v-model="dataLocal[index].first" />
		  </vs-td>
		  <vs-td :data="item.second">
		    <vs-input class="w-full" v-model="dataLocal[index].second" />
		  </vs-td>
		  <vs-td :data="item.third">
		    <vs-input class="w-full" v-model="dataLocal[index].third" />
		  </vs-td>
          <vs-td :data="item.coinFixed">
            <vs-input class="w-full" v-model="dataLocal[index].coinFixed" />
          </vs-td>
          <!-- <vs-td :data="item.coinPercent">
            <vs-input class="w-full" v-model="dataLocal[index].coinPercent" />
          </vs-td>
          <vs-td :data="item.limit">
            <vs-input class="w-full" v-model="dataLocal[index].limit" />
          </vs-td> -->
          <vs-td>
            <vs-button class="w-full pl-0 pr-0" color="danger" type="flat" size="small" @click="del" :data-index="index">删除</vs-button>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
	
	<!-- <vs-input class="w-full mb-4" v-model="limit_balance" :label-placeholder="'账户余额限制'" /> -->
  </div>
</template>

<script>

export default {
  props: {
    data: {
      type: String,
      default: '{}'
    }
  },
  data() {
    return {
      dataLocal: [],
	  limit_balance:0
    }
  },
  methods: {
    del(e) {
      this.dataLocal.splice(e.currentTarget.dataset.index, 1)
    },
    add() {
      this.dataLocal.push({})
    },
    getParam() {
		let data = {
			"rule":this.dataLocal,
			"limit_balance":this.limit_balance
		}
      return JSON.stringify(data)
    }
  },
  mounted() {
	  //this.dataLocal = JSON.parse(this.data)
	let data = JSON.parse(this.data);
	this.dataLocal = data.rule || data;
	this.limit_balance = data.limit_balance || 0;
	
    
  }
}
</script>
